import { useId } from 'react';

import { Icon } from '@/shared/types/icon';

export const Gemini = ({ size = 24, ...rest }: Icon) => {
  const id = useId();
  const maskId = `gemini-mask-${id}`;
  const gradientId = `gemini-grad-${id}`;
  const filterId = (n: number) => `gemini-f${n}-${id}`;

  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...rest}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="30"
        height="30"
      >
        <path
          d="M16.0001 1.7777C16.2984 1.7777 16.5578 1.98142 16.6306 2.27081C16.8537 3.15595 17.1447 4.01932 17.5068 4.8592C18.4501 7.05063 19.7445 8.96875 21.3879 10.6121C23.032 12.2555 24.9494 13.5499 27.1408 14.4932C27.9814 14.8553 28.8441 15.1463 29.7292 15.3694C30.0185 15.4422 30.2222 15.7017 30.2223 15.9999C30.2223 16.2982 30.0186 16.5577 29.7292 16.6304C28.8441 16.8535 27.9806 17.1445 27.1408 17.5067C24.9494 18.45 23.0312 19.7444 21.3879 21.3878C19.7445 23.0319 18.4501 24.9492 17.5068 27.1407C17.1447 27.9813 16.8537 28.8439 16.6306 29.729C16.5578 30.0185 16.2984 30.2221 16.0001 30.2221C15.7018 30.2221 15.4423 30.0184 15.3696 29.729C15.1465 28.8439 14.8555 27.9805 14.4934 27.1407C13.55 24.9493 12.2564 23.0311 10.6123 21.3878C8.96805 19.7444 7.05076 18.45 4.85933 17.5067C4.01865 17.1445 3.15608 16.8535 2.27094 16.6304C1.98155 16.5577 1.77783 16.2982 1.77783 15.9999C1.77787 15.7017 1.98157 15.4422 2.27094 15.3694C3.15609 15.1463 4.01945 14.8554 4.85933 14.4932C7.0508 13.5498 8.96888 12.2555 10.6123 10.6121C12.2557 8.96875 13.55 7.05067 14.4934 4.8592C14.8555 4.01851 15.1465 3.15596 15.3696 2.27081C15.4423 1.98144 15.7018 1.77774 16.0001 1.7777Z"
          fill="black"
        />
        <path
          d="M16.0001 1.7777C16.2984 1.7777 16.5578 1.98142 16.6306 2.27081C16.8537 3.15595 17.1447 4.01932 17.5068 4.8592C18.4501 7.05063 19.7445 8.96875 21.3879 10.6121C23.032 12.2555 24.9494 13.5499 27.1408 14.4932C27.9814 14.8553 28.8441 15.1463 29.7292 15.3694C30.0185 15.4422 30.2222 15.7017 30.2223 15.9999C30.2223 16.2982 30.0186 16.5577 29.7292 16.6304C28.8441 16.8535 27.9806 17.1445 27.1408 17.5067C24.9494 18.45 23.0312 19.7444 21.3879 21.3878C19.7445 23.0319 18.4501 24.9492 17.5068 27.1407C17.1447 27.9813 16.8537 28.8439 16.6306 29.729C16.5578 30.0185 16.2984 30.2221 16.0001 30.2221C15.7018 30.2221 15.4423 30.0184 15.3696 29.729C15.1465 28.8439 14.8555 27.9805 14.4934 27.1407C13.55 24.9493 12.2564 23.0311 10.6123 21.3878C8.96805 19.7444 7.05076 18.45 4.85933 17.5067C4.01865 17.1445 3.15608 16.8535 2.27094 16.6304C1.98155 16.5577 1.77783 16.2982 1.77783 15.9999C1.77787 15.7017 1.98157 15.4422 2.27094 15.3694C3.15609 15.1463 4.01945 14.8554 4.85933 14.4932C7.0508 13.5498 8.96888 12.2555 10.6123 10.6121C12.2557 8.96875 13.55 7.05067 14.4934 4.8592C14.8555 4.01851 15.1465 3.15596 15.3696 2.27081C15.4423 1.98144 15.7018 1.77774 16.0001 1.7777Z"
          fill={`url(#${gradientId})`}
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <g filter={`url(#${filterId(0)})`}>
          <path
            d="M-0.790498 24.0156C2.49605 25.1828 6.27351 22.9944 7.64668 19.1277C9.01986 15.261 7.46876 11.1802 4.18221 10.0131C0.89566 8.84591 -2.88179 11.0343 -4.25497 14.901C-5.62815 18.7677 -4.07705 22.8485 -0.790498 24.0156Z"
            fill="#FFE432"
          />
        </g>
        <g filter={`url(#${filterId(1)})`}>
          <path
            d="M13.802 11.267C18.3172 11.267 21.9774 7.52631 21.9774 2.91192C21.9774 -1.70247 18.3172 -5.44317 13.802 -5.44317C9.28693 -5.44317 5.62671 -1.70247 5.62671 2.91192C5.62671 7.52631 9.28693 11.267 13.802 11.267Z"
            fill="#FC413D"
          />
        </g>
        <g filter={`url(#${filterId(2)})`}>
          <path
            d="M10.6248 37.9868C15.3381 37.7564 18.917 32.6198 18.6185 26.514C18.32 20.4081 14.2572 15.6452 9.54395 15.8756C4.83068 16.106 1.25179 21.2425 1.55027 27.3484C1.84876 33.4542 5.91158 38.2172 10.6248 37.9868Z"
            fill="#00B95C"
          />
        </g>
        <g filter={`url(#${filterId(3)})`}>
          <path
            d="M10.6248 37.9868C15.3381 37.7564 18.917 32.6198 18.6185 26.514C18.32 20.4081 14.2572 15.6452 9.54395 15.8756C4.83068 16.106 1.25179 21.2425 1.55027 27.3484C1.84876 33.4542 5.91158 38.2172 10.6248 37.9868Z"
            fill="#00B95C"
          />
        </g>
        <g filter={`url(#${filterId(4)})`}>
          <path
            d="M15.3453 34.293C19.2966 31.8889 20.3542 26.4135 17.7075 22.0635C15.0607 17.7134 9.71197 16.1359 5.76065 18.5401C1.80932 20.9442 0.751732 26.4195 3.39845 30.7696C6.04517 35.1196 11.3939 36.6971 15.3453 34.293Z"
            fill="#00B95C"
          />
        </g>
        <g filter={`url(#${filterId(5)})`}>
          <path
            d="M31.3164 20.6228C35.7576 20.6228 39.3579 17.1559 39.3579 12.8791C39.3579 8.60242 35.7576 5.13546 31.3164 5.13546C26.8752 5.13546 23.2749 8.60242 23.2749 12.8791C23.2749 17.1559 26.8752 20.6228 31.3164 20.6228Z"
            fill="#3186FF"
          />
        </g>
        <g filter={`url(#${filterId(6)})`}>
          <path
            d="M-3.94869 19.7245C0.140559 22.8343 6.11452 21.8586 9.39453 17.5454C12.6745 13.2322 12.0185 7.21475 7.92927 4.10504C3.84002 0.995319 -2.13395 1.97094 -5.41396 6.28414C-8.69396 10.5973 -8.03794 16.6148 -3.94869 19.7245Z"
            fill="#FBBC04"
          />
        </g>
        <g filter={`url(#${filterId(7)})`}>
          <path
            d="M17.0045 24.3208C21.8855 27.6766 28.3554 26.7417 31.4554 22.2327C34.5555 17.7237 33.1117 11.348 28.2307 7.99222C23.3497 4.63643 16.8798 5.5713 13.7798 10.0803C10.6798 14.5893 12.1235 20.965 17.0045 24.3208Z"
            fill="#3186FF"
          />
        </g>
        <g filter={`url(#${filterId(8)})`}>
          <path
            d="M25.8782 0.754007C27.1199 2.44233 25.5243 5.72498 22.3143 8.086C19.1042 10.447 15.4953 10.9924 14.2535 9.30404C13.0117 7.61573 14.6074 4.33307 17.8174 1.97204C21.0275 -0.388982 24.6364 -0.934316 25.8782 0.754007Z"
            fill="#749BFF"
          />
        </g>
        <g filter={`url(#${filterId(9)})`}>
          <path
            d="M15.6843 8.83668C20.6486 4.23191 22.3526 -2.00268 19.4901 -5.08867C16.6276 -8.17465 10.2828 -6.94343 5.31841 -2.33866C0.354054 2.26612 -1.34987 8.50071 1.51259 11.5867C4.37505 14.6727 10.7199 13.4415 15.6843 8.83668Z"
            fill="#FC413D"
          />
        </g>
        <g filter={`url(#${filterId(10)})`}>
          <path
            d="M5.50779 25.3765C8.45835 27.4883 11.8458 27.8092 13.0739 26.0933C14.302 24.3774 12.9057 21.2744 9.95513 19.1627C7.00457 17.0509 3.6171 16.73 2.389 18.4459C1.1609 20.1618 2.55723 23.2647 5.50779 25.3765Z"
            fill="#FFEE48"
          />
        </g>
      </g>
      <defs>
        <filter
          id={filterId(0)}
          x="-6.37235"
          y="8.08197"
          width="16.1364"
          height="17.8648"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.808582" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(1)}
          x="-2.19142"
          y="-13.2613"
          width="31.9869"
          height="32.3464"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.90906" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(2)}
          x="-5.11328"
          y="9.22137"
          width="30.3954"
          height="35.4196"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.32309" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(3)}
          x="-5.11328"
          y="9.22137"
          width="30.3954"
          height="35.4196"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.32309" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(4)}
          x="-4.70532"
          y="10.7694"
          width="30.5166"
          height="31.2943"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.32309" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(5)}
          x="16.9591"
          y="-1.18035"
          width="28.7146"
          height="28.119"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.15791" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(6)}
          x="-13.2258"
          y="-3.43776"
          width="30.4321"
          height="30.7051"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.86197" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(7)}
          x="7.0349"
          y="0.866951"
          width="31.1654"
          height="30.5791"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.55585" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(8)}
          x="9.25806"
          y="-4.80097"
          width="21.6156"
          height="19.66"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.28702" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(9)}
          x="-3.73967"
          y="-10.6522"
          width="28.482"
          height="27.8025"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.93166" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id={filterId(10)}
          x="-2.83835"
          y="12.5611"
          width="21.1396"
          height="19.417"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.39076" result="effect1_foregroundBlur" />
        </filter>
        <linearGradient
          id={gradientId}
          x1="9.86366"
          y1="20.8096"
          x2="24.6374"
          y2="8.35401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4893FC" />
          <stop offset="0.27" stopColor="#4893FC" />
          <stop offset="0.776981" stopColor="#969DFF" />
          <stop offset="1" stopColor="#BD99FE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
